module.exports = __webpack_public_path__ + "img/landing11.42712cd2.jpg";